<template>
  <div class="backgroud-white cs-courseSchedule-editor">
    <div class="text-center">
      <h4>{{ isAdded?'添加校园热点': '校园热点'}}</h4>
    </div>
    <div class="backgroud-gray-popup popup-content-area-small">
      <el-form
        ref="model"
        :rules="rules"
        :model="model"
        label-width="100px"
      >
        <el-form-item
          label="标题"
          prop="title"
        >
          <el-input
            @change="checkAllInputs"
            placeholder="请输入标题"
            v-model="model.title"
            class="input-width"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="描述"
          prop="description"
        >
          <el-input
            placeholder="请输入描述"
            v-model="model.description"
            class="input-width"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="来源"
          prop="source"
        >
          <el-input
            placeholder="请输入来源"
            v-model="model.source"
            class="input-width"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="文章URL"
          prop="linkUrl"
        >
          <el-input
            @change="checkAllInputs"
            placeholder="请输入文章URL"
            v-model="model.linkUrl"
            class="input-width"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属学校">
          <el-select
            v-model="model.universityIds"
            placeholder="请选择所属学校"
            multiple
          >
            <el-option
              v-for="item in universityList"
              :key="item.Id"
              :label="item.Abbreviation"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="启用" prop="enable">
          <el-checkbox v-model="model.enable" class="input-width"></el-checkbox>
        </el-form-item>
        <el-form-item label="置顶" prop="top">
          <el-checkbox v-model="model.top" class="input-width"></el-checkbox>
        </el-form-item>
        <el-form-item label="通知" prop="isPushNotification">
          <el-checkbox v-model="model.isPushNotification" class="input-width"></el-checkbox>
        </el-form-item>
        <el-form-item label="热点图片">
          <el-button
            type="text"
            size="medium"
            @click="uploadSchoolHotImage()"
          >点击上传校园热点图片</el-button>
          <el-button
            type="text"
            size="medium"
            @click="clearSchoolHotImage()"
            v-show="schoolHotImageShowerVisible"
          >清空图片</el-button>
        </el-form-item>
        <el-form-item>
          <image-show
            :src="schoolHotImageSrc"
            :isVisible="schoolHotImageShowerVisible"
            style="max-width:300px"
          ></image-show>
        </el-form-item>
        <template>
          <el-dialog
            center
            title="上传校园热点图片"
            :show-close="true"
            :close-on-click-modal="false"
            width="700px"
            :visible.sync="schoolHotImageUploaderVisible"
            top="8vh"
            z-index="2000"
          >
            <blobUploader
              @closeEditor="onCloseSchoolHotImageUploader"
              @blobUploadError="onScoreUploadError"
              @blobUploaded="onSchoolHotImageUploaded"
              :type="4"
              :accepts="'.png,.jpg,.jpeg'"
              :isVisible="schoolHotImageUploaderVisible"
              :isAutoSave="true"
            ></blobUploader>
          </el-dialog>
        </template>
      </el-form>
    </div>
    <div
      slot="footer"
      class="dialog-footer popup-footer"
    >
      <el-row>
        <el-col
          :span="20"
          class="footer-left"
        >
          <span v-if="!showError"></span>
          <el-alert
            :closable="false"
            v-if="showError"
            v-bind:title="errorMessage"
            type="error"
            show-icon
          ></el-alert>
        </el-col>
        <el-col
          class="footer-right"
          :span="4"
        >
          <el-button
            :disabled="submitBtnDisable"
            :type="submitBtnClass"
            @click="save()"
          >{{ isAdded?'确认添加': '保存更新'}}</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import blobUploader from "@/components/fileHandler/blobUploader";
import imageShow from "@/components/fileHandler/imageShow";

import { saveSchoolHot, updateSchoolHot } from "@/service/schoolHot.service";
import { getUniversityList } from "@/service/common.service";

export default {
  props: {
    dataIn: {}
  },
  data() {
    let urlValidator = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入校园热点URL"));
      }
      let regexp = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
      if (regexp.test(value)) {
        return callback();
      }
      return callback(new Error("请输入正确的URL"));
    };
    return {
      universityList: [],
      model: {
        title: "",
        description: "",
        pictureUrl: "",
        linkUrl: "",
        enable: false,
        fileId: "",
        top: false,
        source: "速成教育公众号",
        isPushNotification: false,
        universityIds: []
      },
      submitBtnClass: "info",
      submitBtnDisable: true,
      isAdded: false,
      showError: false,
      errorMessage: "",
      rules: {
        title: [
          {
            required: true,
            message: "请输入标题",
            trigger: "blur"
          }
        ],
        linkUrl: [
          {
            required: true,
            message: "请输入校园热点URL",
            trigger: "blur"
          },
          {
            validator: urlValidator,
            trigger: "blur"
          }
        ]
      },

      schoolHotImageUploaderVisible: false,
      schoolHotImageShowerVisible: false,
      schoolHotImageSrc: ""
    };
  },
  components: {
    blobUploader,
    imageShow
  },
  created() {
    this.schoolHotImageSrc = "";
    this.loadUniversityListFromServer();
    this.init();
  },
  methods: {
    async loadUniversityListFromServer() {
      let result = await getUniversityList();
      this.universityList = !!result && result.success ? result.data : [];
    },
    checkAllInputs(value, onlyCheck) {
      let isValid = true;

      if (!this.$refs["model"]) return false;

      this.$refs["model"].validate(valid => {
        if (!valid) {
          isValid = false;
          return;
        }
      });

      if (onlyCheck) return isValid;

      this.submitBtnClass = isValid ? "primary" : "info";
      this.submitBtnDisable = !isValid;

      return isValid;
    },
    save() {
      let isValid = this.checkAllInputs(null, true);
      if (!isValid) return false;

      this.submitBtnDisable = true;
      if (this.isAdded) {
        let result = saveSchoolHot(
          this.model.title,
          this.model.description,
          this.model.linkUrl,
          this.model.pictureUrl,
          this.model.enable,
          this.model.top,
          this.model.fileId,
          this.model.source,
          this.model.isPushNotification,
          this.model.universityIds
        ).then(result => {
          if (!result.success) {
            this.errorMessage = result.message;
            this.showError = true;
          } else {
            this.$message({
              message: "保存成功",
              type: "success"
            });
            this.showError = false;
            this.$emit("saveSuccess", this.isAdded, result.data);
            this.close();
          }
          this.submitBtnDisable = false;
        });
      } else {
        let result = updateSchoolHot(
          this.model.id,
          this.model.title,
          this.model.description,
          this.model.linkUrl,
          this.model.pictureUrl,
          this.model.enable,
          this.model.top,
          this.model.fileId,
          this.model.source,
          this.model.isPushNotification,
          this.model.universityIds
        ).then(result => {
          if (!result.success) {
            this.errorMessage = result.message;
            this.showError = true;
          } else {
            this.$message({
              message: "更新成功",
              type: "success"
            });
            this.showError = false;
            this.$emit("saveSuccess", this.isAdded, result.data);
            this.close();
          }
          this.submitBtnDisable = false;
        });
      }
    },
    close() {
      this.$emit("closeDialog");
    },
    init() {
      if (!!this.dataIn && !!this.dataIn.Id) {
        this.isAdded = false;
        this.model.id = this.dataIn.Id;
        this.model.title = this.dataIn.Title;
        this.model.description = this.dataIn.Description;
        this.model.linkUrl = this.dataIn.LinkUrl;
        this.model.pictureUrl = this.dataIn.PictureUrl;
        this.model.enable = this.dataIn.Enable;
        this.model.top = this.dataIn.Top;
        this.model.isPushNotification = this.dataIn.IsPushNotification;
        this.model.universityIds = this.__convertIdsFromUniversities(
          this.dataIn.Universities
        );
        this.submitBtnClass = "primary";
        this.submitBtnDisable = false;
        if (this.dataIn.PictureUrl) {
          this.schoolHotImageShowerVisible = true;
          this.schoolHotImageSrc = this.dataIn.PictureUrl;
        } else {
          this.schoolHotImageShowerVisible = false;
          this.schoolHotImageSrc = "";
        }
      } else {
        this.isAdded = true;
        this.model.id = 0;
        this.model.title = "";
        this.model.description = "";
        this.model.linkUrl = "";
        this.model.enable = true;
        this.model.top = false;
        this.model.pictureUrl = "";
        this.submitBtnClass = "info";
        this.submitBtnDisable = true;
        this.model.isPushNotification = true;
        this.model.universityIds = [];

        this.schoolHotImageShowerVisible = false;
        this.schoolHotImageSrc = "";
      }
    },
    uploadSchoolHotImage() {
      this.schoolHotImageUploaderVisible = true;
    },

    clearSchoolHotImage() {
      this.model.pictureUrl = "";
      this.schoolHotImageShowerVisible = false;
      this.schoolHotImageSrc = "";
    },
    onCloseSchoolHotImageUploader() {
      this.closeSchoolHotImageUploader();
    },
    onScoreUploadError() {},
    closeSchoolHotImageUploader() {
      this.schoolHotImageUploaderVisible = false;
    },
    onSchoolHotImageUploaded(data) {
      if (!!data) {
        this.model.pictureUrl = data.Path;
        this.model.fileId = data.FileId;
        this.schoolHotImageSrc = data.Path;
        this.schoolHotImageShowerVisible = true;
        this.schoolHotImageUploaderVisible = false;
      }
    },
    isPhone(rule, value, callback) {
      if (!value) {
        return callback(new Error("输入不可以为空"));
      }
      var pattern = /^1[34578]\d{9}$/;
      if (pattern.test(value)) {
        return callback();
      }
      return callback(new Error("输入的手机号错误"));
    },
    __convertIdsFromUniversities(universities) {
      let result = [];

      universities.forEach(m => {
        result.push(m.Key);
      });

      return result;
    }
  },
  watch: {
    dataIn: function() {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/schoolHotEditor.vue